import React, { useMemo, useState } from "react";
import SearchIcon from "@mui/icons-material/Search";
import NavSectionItem from "./NavSectionItem";

export default function NavSection({ navConfig }) {
  const [searchText, setSearchText] = useState("");

  const filteredGroups = useMemo(() => {
    if (!searchText.trim()) return navConfig || [];

    const query = searchText.toLowerCase();
    return (navConfig || [])
      .map((group) => ({
        ...group,
        items: (group.items || []).filter((item) =>
          String(item.title || "")
            .toLowerCase()
            .includes(query),
        ),
      }))
      .filter((group) => group.items.length > 0);
  }, [navConfig, searchText]);

  const flatResults = useMemo(() => {
    if (!searchText.trim()) return null;
    const query = searchText.toLowerCase();
    return (navConfig || [])
      .flatMap((group) => group.items || [])
      .filter((item) =>
        String(item.title || "")
          .toLowerCase()
          .includes(query),
      );
  }, [navConfig, searchText]);

  return (
    <div className="sidebar-nav">
      <div className="sidebar-nav__search">
        <SearchIcon className="sidebar-nav__search-icon" fontSize="small" />
        <input
          type="text"
          placeholder="Search menu..."
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
          aria-label="Search menu"
        />
      </div>

      <nav className="sidebar-nav__menu" aria-label="Dashboard sections">
        {flatResults
          ? flatResults.map((item) => (
              <NavSectionItem key={item.path} data={item} />
            ))
          : filteredGroups.map((group) => (
              <div key={group.label} className="sidebar-nav__group">
                <p className="sidebar-nav__group-label">{group.label}</p>
                {(group.items || []).map((item) => (
                  <NavSectionItem key={item.path} data={item} />
                ))}
              </div>
            ))}
      </nav>
    </div>
  );
}
